import React from 'react';
import c from 'classnames';
import s from './ShopCardRoot.scss';
const ShopCardRoot = ({ width, height, className, 'aria-hidden': ariaHidden, children })=>{
    return /*#__PURE__*/ React.createElement("div", {
        className: c(s['root'], className),
        style: {
            width,
            height
        },
        "aria-hidden": ariaHidden
    }, children);
};
ShopCardRoot.displayName = 'ShopCardRoot';
export default ShopCardRoot;

//# sourceMappingURL=ShopCardRoot.js.map